import { Reveal, SectionHeading } from "./Reveal";
import { ServiceCard } from "./ServiceCard";
import { SERVICES } from "../../lib/data";

const SPANS = [true, false, false, false, false, true, true, true];

export const LoanSolutions = () => (
  <section id="solutions" className="bg-white py-24 md:py-32" data-testid="loan-solutions-section">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <div className="flex flex-wrap items-end justify-between gap-8">
        <SectionHeading
          overline="Our Loan Solutions"
          title="Financing, Structured Around You."
          sub="Eight specialised solution areas covering property, business, and corporate funding requirements."
          testId="solutions-heading"
        />
        <Reveal delay={0.2}>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-gray-400">08 Solutions</p>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug} delay={(i % 4) * 0.08} className={SPANS[i] ? "h-full lg:col-span-2" : "h-full"} y={32}>
            <ServiceCard service={s} wide={SPANS[i]} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
